import { useContext } from 'react';
import { HttpContext } from '@/components/providers/http/http-provider';

export function useHttp() {
  return useContext(HttpContext);
}